import React from "react";
import { Checkbox, FormControl, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  display: "block",
  padding: "0px",
  marginRight: "10px",
  "& .MuiSvgIcon-root ": {
    width: "20px",
    height: "20px",
    marginTop: "-2px",
  },
}));

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.text.primary,
  position: "relative",
  transform: "none",
  whiteSpace: "normal",
  overflow: "initial",
  textOverflow: "initial",
}));

const CheckboxField = ({ children, name, handleChange }) => {
  return (
    <FormControl
      variant="standard"
      sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", marginBottom: "10px" }}
    >
      <StyledCheckbox id={name} name={name} onChange={handleChange} />
      <StyledLabel>{children}</StyledLabel>
    </FormControl>
  );
};

export default CheckboxField;
